import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApplicationThankYouMessage from "./ApplicationThankYouMessage";
import ApplicationFinalStep from "./ApplicationFinalStep";

  const categories = [
    "Frontend Development",
    "App Development",
    "Data Science",
    "Artificial Intelligence",
    "Mathematics",
    "Backend Development",
    "Dev-Ops",
  ];
  const allTopics = {
    "Frontend Development": [
      "HTML",
      "CSS",
      "JavaScript",
      "ReactJs",
      "Vue.js",
      "Angular.Js",
      "Version Control",
      "Responsiveness",
      "Redux",
    ],
    "Backend Development": [
      "DSA",
      "Java",
      "NodeJs",
      "Python",

      "MongoDb",
      "MySql",
    ],
    "Data Science": ["Python", "Statistics", "Linear Algebra", " Algorithms"],
    "App Development": ["React Native", "Flutter", "Kotlin", "Swift"],
    "Artificial Intelligence": [
      "Python",
      "Machine Learning",
      "Deep Learning",
      "Generative AI",
      "LLM",
    ],
    Mathematics: ["Algebra"],
    "Hosting/Deployment": ["Cloud Hosting", "Web Hosting", "VPS Hosting"],
  };

const timeOptions = [
  "I can work daily",
  "I can work only on weekends and holidays",
  "I can work occasionally",
  "I can work whenever I get free",
]; // Time options

const Application = ({ expertDetails }) => {
  const [mobile, setMobile] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const topics = allTopics[selectedCategory] || [];
  const [selectedTopic, setSelectedTopic] = useState("");
  const [timeSpent, setTimeSpent] = useState("");
  const [identityProof, setIdentityProof] = useState("");
  const [topicExpertiseProof, setTopicExpertiseProof] = useState("");
  const [topicExpertiseDescription, setTopicExpertiseDescription] =
    useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [received, setReceived] = useState(false);
  const [verifiedByTeam, setVerifiedByTeam] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  // =============================================

  // ==================functions======================
  const fetchApplicationStatus = async (id) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/expert/application-status/${id}`
      );
      const data = await response.json();
      setReceived(data.data.received);
      console.log(data.data.isVerified)
      setVerifiedByTeam(data.data.isVerified);
    } catch (error) {
      console.error("Error fetching application status:", error);
    }
  };

  //handle category change
  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setSelectedCategory(newCategory);
    setSelectedTopic("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("EXPERT_AUTH_TOKEN");

    const headers = new Headers();
    headers.append("Authorization", token);

    const formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("selectedCategory", selectedCategory);
    formData.append("selectedTopic", selectedTopic);
    formData.append("timeSpent", timeSpent);
    formData.append("identityProof", identityProof);
    formData.append("topicExpertiseProof", topicExpertiseProof);
    formData.append("topicExpertiseDescription", topicExpertiseDescription);
    formData.append("additionalInfo", additionalInfo);

    const fetchOptions = {
      method: "POST",
      headers: headers,
      body: formData,
    };

    try {
      const response = await fetch(
        `${baseUrl}/api/expert/application`,
        fetchOptions
      );
      // const data = await response.json();

      if (response.status === 200) {
        toast.success("Form submitted successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        fetchApplicationStatus(expertDetails._id);
      } else if (response.status === 400) {
        toast.error("Bad request", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Internal Server Error: ", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  useEffect(() => {
    fetchApplicationStatus(expertDetails._id);
  }, []);

  return (
    <div>
      {verifiedByTeam ? (
        <ApplicationFinalStep />
      ) : received ? (
        <ApplicationThankYouMessage />
      ) : (
        <div className="flex flex-col items-center justify-center bg-gray-100">
          <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-yellow-300 to-red-400 bg-clip-text text-transparent leading-tight my-5">
            Complete your application
          </h1>
          <div className=" rounded-lg shadow-lg p-8 mb-20 w-1/2 space-y-5 bg-white">
            <h2 className="text-2xl font-semibold mb-4 text-center">
              Application Form
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="mobile" className="block font-semibold text-sm">
                  Mobile
                </label>
                <input
                  type="text"
                  id="mobile"
                  className=" px-3 py-2 w-full"
                  placeholder="Enter your mobile number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="category" className="font-semibold text-sm">
                  Choose your category
                </label>
                <p className="text-xs mt-1 mb-2">
                  (You will need to select a relevant topic in the next question
                  based on the category selected)
                </p>
                <select
                  id="category"
                  className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-400"
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                >
                  <option value="">Select a category</option>
                  {categories.map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  htmlFor="topic"
                  className="block font-semibold text-sm mt-8"
                >
                  Choose your topic
                </label>

                <select
                  id="topic"
                  className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-400"
                  value={selectedTopic}
                  onChange={(e) => setSelectedTopic(e.target.value)}
                >
                  <option value="">Select a topic</option>
                  {topics.map((topic) => (
                    <option key={topic} value={topic}>
                      {topic}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  htmlFor="time"
                  className="block font-semibold text-sm mt-8"
                >
                  How much time can you spend?
                </label>
                <p className="text-xs mb-2">
                  (You will be needed to select relevant topic in the next
                  question based on the category selected)
                </p>
                <select
                  id="time"
                  className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-400"
                  value={timeSpent}
                  onChange={(e) => setTimeSpent(e.target.value)}
                >
                  <option value="">Select time</option>
                  {timeOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <div>
                  <label
                    htmlFor="identityProof"
                    className="block font-semibold text-sm mt-8"
                  >
                    Upload your Identity proof
                  </label>
                  <p className="text-xs my-2 mb-2">
                    (Upload any one government-issued document like Aadhaar,
                    Pan, DL, etc)
                  </p>
                  <input
                    type="file"
                    id="identityProof"
                    className="hidden"
                    onChange={(e) => setIdentityProof(e.target.files[0])}
                  />
                  <label
                    htmlFor="identityProof"
                    className="w-full border rounded-md px-5 py-3 bg-blue-500 text-white cursor-pointer text-center"
                  >
                    Choose File
                  </label>
                  {identityProof && (
                    <p className="mt-2"> {identityProof.name}</p>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor="topicExpertiseProof"
                  className="block font-semibold text-sm mt-8"
                >
                  Topic expertise proof
                </label>
                <p className="text-xs my-2 ">
                  (You can submit your degree/marksheet/skill
                  certificate/achievement or any other thing that will tell us
                  about your expertise in the selected topic. Note: You can also
                  tell us about your topic expertise in the next question)
                </p>
                <input
                  id="topicExpertiseProof"
                  type="file"
                  className="hidden"
                  onChange={(e) => setTopicExpertiseProof(e.target.files[0])}
                />
                <label
                  htmlFor="topicExpertiseProof"
                  className="w-full border rounded-md px-5 py-3 bg-blue-500 text-white cursor-pointer text-center"
                >
                  Choose File
                </label>
                {topicExpertiseProof && (
                  <p className="mt-2"> {topicExpertiseProof.name}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="topicExpertiseDescription"
                  className="block font-semibold text-sm mt-8"
                >
                  Tell us about your topic expertise
                </label>
                <textarea
                  id="topicExpertiseDescription"
                  className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-400"
                  placeholder="Tell us about your topic expertise"
                  value={topicExpertiseDescription}
                  onChange={(e) => setTopicExpertiseDescription(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="additionalInfo"
                  className="block font-semibold text-sm"
                >
                  Anything else you would like to ask/tell/inform us?
                </label>
                <textarea
                  id="additionalInfo"
                  className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-400"
                  placeholder="Anything else you would like to ask/tell/inform us?"
                  value={additionalInfo}
                  onChange={(e) => setAdditionalInfo(e.target.value)}
                />
              </div>
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 self-center"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Application;
